import { AB_TEST_FLAGS, AbTestFlag, AbTestVariants } from './abTestFlags';

export type ExperimentAssignment = [experimentId: number, variationId: number];

const VARIATIONS_COOKIE = 'x-kml-variations';
const TRACKING_COOKIE = 'x-kml-tracking';
const NO_ASSIGNMENT = '-';
// At most 15 digits, so Number() converts every ID exactly.
const ID = /^[0-9]{1,15}$/;

function readCookie(cookies: string, name: string) {
  return new RegExp(`(?:^|;\\s*)${name}=([^;]*)`).exec(cookies)?.[1];
}

function readPairs(cookies: string, name: string): [string, string][] {
  const raw = readCookie(cookies, name);
  let value;

  try {
    value = raw && decodeURIComponent(raw);
  } catch {
    return [];
  }

  if (!value || value === NO_ASSIGNMENT) {
    return [];
  }

  return value.split(',').flatMap((pair): [string, string][] => {
    const separator = pair.indexOf(':');
    return separator > 0
      ? [[pair.slice(0, separator), pair.slice(separator + 1)]]
      : [];
  });
}

function isKnownVariant(flag: string, variant: string) {
  return (
    Object.prototype.hasOwnProperty.call(AB_TEST_FLAGS, flag) &&
    (AB_TEST_FLAGS[flag as AbTestFlag] as readonly string[]).includes(variant)
  );
}

export function readVariants(cookies: string): AbTestVariants {
  return Object.fromEntries(
    readPairs(cookies, VARIATIONS_COOKIE).filter(([flag, variant]) =>
      isKnownVariant(flag, variant),
    ),
  );
}

export function readExperimentAssignments(
  cookies: string,
): ExperimentAssignment[] {
  return readPairs(cookies, TRACKING_COOKIE)
    .filter(([experimentId, variationId]) =>
      [experimentId, variationId].every((id) => ID.test(id)),
    )
    .map(([experimentId, variationId]) => [
      Number(experimentId),
      Number(variationId),
    ]);
}
